import { calculateEntryAmount } from '@/services/utils';
angular.module('leanlaw').controller('InvoiceMatterCtrl', ['$scope', '$q', '$stateParams', '$state', 'userService', 'leanLawApi', 'invoiceFilterService', 'matterManager', 'clientManager', 'alerts', 'entriesManager', 'expenseManager', 'chargeManager', 'onboardService', '$rootScope', function ($scope, $q, $stateParams, $state, userService, leanLawApi, invoiceFilterService, matterManager, clientManager, alerts, entriesManager, expenseManager, chargeManager, onboardService, $rootScope) {
  $scope.items = {};
  $scope.state = invoiceFilterService.state;
  let _loadedState;
  $scope.loading = true;
  alerts.dismiss();
  $rootScope.reloadExpenses = reload;

  // Function to generate comma-separated string of checked checkboxes
  function getCheckboxesChecked() {
    const checkedBoxes = [];

    // Check Billable Time
    if ($scope.items.hours && $scope.items.hours.include) {
      checkedBoxes.push('billable time');
    }

    // Check Non-Billable Time or Fixed Fee Time (based on fixed matters)
    if ($scope.items.none && $scope.items.none.include) {
      if ($scope.items.fixed && $scope.items.fixed.length > 0) {
        checkedBoxes.push('fixed fee time');
      } else {
        checkedBoxes.push('non billable time');
      }
    }

    // Check Fixed Fee Time (separate checkbox)
    if ($scope.items.fixedHours && $scope.items.fixedHours.include) {
      checkedBoxes.push('fixed fee time');
    }

    // Check Fixed Fee charges
    if ($scope.items.fixed && $scope.items.fixed.length > 0) {
      $scope.items.fixed.forEach(fixed => {
        if (fixed.include) {
          checkedBoxes.push('fixed fee');
        }
      });
    }

    // Check individual charges
    if ($scope.items.charges && $scope.items.charges.length > 0) {
      $scope.items.charges.forEach(charge => {
        if (charge.include) {
          checkedBoxes.push('fixed fee');
        }
      });
    }

    // Check Expenses
    if ($scope.items.expenses && $scope.items.expenses.include) {
      checkedBoxes.push('expenses');
    }

    // Check Above Fixed Fee Limit
    if ($scope.items.extra && $scope.items.extra.include) {
      checkedBoxes.push('above fixed fee limit');
    }

    // Check computed items
    if ($scope.items.computed && $scope.items.computed.length > 0) {
      $scope.items.computed.forEach(computed => {
        if (computed.include) {
          checkedBoxes.push(computed.description.toLowerCase());
        }
      });
    }

    // Remove duplicates and return
    return [...new Set(checkedBoxes)].join(', ');
  }
  activate();

  // Total with computed fields if set
  $scope.total = function () {
    let total = 0;
    if ($scope.items.hours && $scope.items.hours.include) {
      total += $scope.items.hours.amount;
    }
    if ($scope.items.fixed) {
      $scope.items.fixed.forEach(fixed => {
        if (fixed.include) {
          total += fixed.amount;
        }
      });
    }
    if ($scope.items.charges) {
      $scope.charges.forEach(c => {
        if (c.include) {
          total += c.amount;
        }
      });
    }
    if ($scope.items.expenses && $scope.items.expenses.include) {
      total += $scope.items.expenses.amount;
    }
    if ($scope.items.extra && $scope.items.extra.include) {
      total += $scope.items.extra.amount;
    }
    if ($scope.items.computed) {
      var serviceTotal = $scope.items.hours.amount;
      $scope?.items?.charges?.forEach(charge => {
        serviceTotal += charge.amount;
      });
      $scope.items.computed.forEach(c => {
        c.amount = c.computed.settings.services * 0.01 * serviceTotal;
        if (!c.include) return;
        total += c.amount;
      });
    }
    return total;
  };

  // These use absolute state names on purpose. A relative '.expense' is
  // resolved against whatever state is current, so it blows up as soon as one
  // of these editors is already open.
  $scope.expenseSelected = function (expense) {
    if (expense.accounting) {
      return $state.go('billing.invoice.matter.qbexpense', {
        expenseId: expense.id
      });
    }
    return $state.go('billing.invoice.matter.expense', {
      expenseId: expense.id
    });
  };
  $scope.chargeSelected = function (charge) {
    return $state.go('billing.invoice.matter.charge', {
      chargeId: charge.id
    });
  };

  // Only counts things that go on the invoice as records of their own - the
  // fixed fee limit adjustment and the administrative fee are derived from
  // whatever else ends up on it.
  $scope.nothingSelected = function () {
    return isEmpty(selectedRecords());
  };
  $scope.clear = function (entries, billable) {
    const buttons = {
      cancel: {
        label: 'Cancel'
      },
      ok: {
        label: 'Mark as Billed',
        className: 'btn-primary',
        callback: () => {
          writeoff(entries, {
            billed: true
          });
        }
      }
    };
    if ($scope.me.adjustments) {
      buttons.adjust = {
        label: 'Write-down',
        className: 'btn',
        callback: () => {
          writeoff(entries, {
            billed: true,
            adjustment: true
          });
        }
      };
    }
    if (billable) {
      buttons.nonbillable = {
        label: 'Mark as Non-Billable',
        className: 'btn',
        callback: () => {
          // If we pick this, flip entries to non-billable (billable=false) otherwise leave alone
          // billable=null
          writeoff(entries, {
            billed: true,
            billingType: billable ? 'billable' : 'nonBillable'
          });
        }
      };
    }
    let instructions = 'This will mark the time entries as billed';
    instructions += buttons.length > 1 ? ', but in different ways that affect reporting.' : '.';
    if ($scope.me.adjustments) {
      instructions += ' Adjusting to zero keeps the time for productivity reports, but marks the billable time down to zero.';
    }
    bootbox.dialog({
      message: `<p>${instructions}</p> <p>It will NOT delete the time entries.</p>`,
      title: 'Clear out time entries from billing?',
      buttons
    });
  };

  // Creates the invoice straight from what is selected here. The back end
  // builds the line items, memo, totals and trust memo from the records we
  // point it at plus the company/client invoice settings, and submits to
  // QuickBooks by itself when the firm doesn't use the draft or approval
  // workflow. Anything else about the invoice is changed from Drafts.
  $scope.create = () => {
    const records = selectedRecords();
    if (isEmpty(records)) return;

    // The back end works out whether this is a matter or a client level
    // invoice from the records, and refuses to put several matters on one
    // invoice unless the client is set up for client billing. Say so here
    // where we can explain what to do about it.
    if ($scope.client && !$scope.client.billing.billClient && selectedMatterIds(records).length > 1) {
      return alerts.error(`The invoice contains multiple ${$scope.me.terms.matter}s but the client is set up for ${$scope.me.terms.matter} level accounting. Please invoice the ${$scope.me.terms.matter}s individually.`);
    }
    const selected = {
      entries: idsOf(records.entries),
      expenses: idsOf(records.expenses),
      charges: idsOf(records.charges)
    };
    bootbox.confirm($scope.draft ? '<h5>Create draft invoice?</h5><p>This will lock the time entries. You can undo this if you made a mistake.</p>' : '<h5>Create invoice and submit it to QuickBooks?</h5><p>This will lock the time entries. You can undo this if you made a mistake.</p>', yes => {
      if (!yes) return;
      $scope.creating = true;
      $scope.$applyAsync(); // bootbox calls back from outside a digest
      leanLawApi.createInvoice({
        body: {
          method: 'step-by-step',
          filter: createFilter(),
          items: selected
        }
      }).then(() => {
        alerts.success($scope.draft ? "Draft invoice was created - it can be found under 'Drafts'" : 'The invoice was created and sent to QuickBooks. If you see any issues you can Undo the invoice which also removes it from QuickBooks.');
        onboardService.reload();
        $state.go('billing.invoice.summary');
      }).catch(alerts.error).finally(() => {
        $scope.creating = false;
      });
    });
  };

  ////////////////////////////////////////

  // What the user ticked. Non-billable and fixed fee time are both in
  // nonBillableEntries - they share the one checkbox on this page.
  function selectedRecords() {
    const entries = [];
    if ($scope.items.hours && $scope.items.hours.include) {
      entries.push(...($scope.billableEntries || []));
    }
    if ($scope.items.none && $scope.items.none.include) {
      entries.push(...($scope.nonBillableEntries || []));
    }
    return {
      entries,
      expenses: $scope.items.expenses && $scope.items.expenses.include ? $scope.expenses || [] : [],
      charges: ($scope.items.charges || []).filter(c => c.include)
    };
  }
  function isEmpty(records) {
    return !records.entries.length && !records.expenses.length && !records.charges.length;
  }
  function idsOf(records) {
    return records.map(record => ({
      id: record.id
    }));
  }
  function selectedMatterIds(records) {
    return _.uniq([].concat(records.entries, records.expenses, records.charges).map(record => record.matter && record.matter.id).filter(id => !!id));
  }
  function createFilter() {
    const query = invoiceFilterService.filterQuery();
    const filter = {
      clientId: $scope.client ? $scope.client.id : null,
      matterId: $scope.matter ? $scope.matter.id : null,
      startDate: query.startDate,
      endDate: query.endDate,
      timeOffset: new Date().getTimezoneOffset(),
      checkboxesChecked: getCheckboxesChecked()
    };
    if (invoiceFilterService.state.expenseRange) {
      const expenseQuery = invoiceFilterService.expenseFilterQuery();
      filter.expenseRange = {
        startDate: expenseQuery.startDate,
        endDate: expenseQuery.endDate
      };
    }
    return filter;
  }
  function activate() {
    userService.me().then(me => {
      $scope.me = me;
      $scope.customFlagLabel = me.company.settings.labels && me.company.settings.labels.customFlag;
      // The back end submits the invoice to QuickBooks on creation unless the
      // firm uses the draft or approval workflow (see InvoiceCreator), so
      // mirror that condition to label the button and confirmation correctly.
      const workflow = me.company.settings.workflow || {};
      $scope.draft = !!(workflow.invoiceDraft || workflow.invoiceApprove) || !me.company.integration.quickbooks;
    });
    if ($stateParams.matterId) {
      matterManager.get($stateParams.matterId).then(matter => {
        if (!matter.access.billing) {
          $scope.noAccess = true;
          $scope.loading = false;
          return;
        }
        $scope.matter = matter;
        $scope.codes = matter.client.codes && matter.client.codes.ledes;
        setupFilterWatch();
      });
    } else if ($stateParams.clientId) {
      clientManager.get($stateParams.clientId, {
        matters: 'include',
        scope: 'involved'
      }).then(client => {
        $scope.client = client;
        $scope.codes = client.codes && client.codes.ledes;
        setupFilterWatch();
      });
    } else {
      throw new Error('no matter or client id?!');
    }
  }
  function matterIds(items) {
    var matters = _.groupBy(items, function (i) {
      return i.matter.id;
    });
    return _.keys(matters);
  }
  function setupFilterWatch() {
    $scope.$watch('state', function (state, previous) {
      if (!invoiceFilterService.reload(_loadedState)) return;
      _loadedState = angular.copy(invoiceFilterService.state);
      if (!$scope.matter && !$scope.client) return;
      reload();
    }, true);
  }
  function writeoff(entries, options) {
    entries.saving = true;
    return leanLawApi.markEntries({
      body: {
        ...options,
        entries: entries.map(e => ({
          id: e.id
        }))
      }
    }).then(function () {
      entries.saving = false;
      reload();
    }).catch(function (err) {
      alerts.error(err);
    }).finally(function () {
      entries.saving = false;
    });
  }
  function reload() {
    $scope.loading = true;
    var query = invoiceFilterService.filterQuery();
    if ($stateParams.mattersIds) {
      query.mattersIds = $stateParams.mattersIds;
    }
    query.chargeCompleted = true;
    var entriesRequest = $scope.matter ? entriesManager.listForMatter($scope.matter, query) : entriesManager.listForClient($scope.client, query);
    var chargesRequest = $scope.matter ? chargeManager.listForMatter($scope.matter.id, query) : chargeManager.listForClient($scope.client.id, query);
    var expenseQuery = invoiceFilterService.expenseFilterQuery();
    if ($stateParams.mattersIds) {
      expenseQuery.mattersIds = $stateParams.mattersIds;
    }
    var expensesRequest = $scope.matter ? expenseManager.listForMatter($scope.matter.id, expenseQuery) : expenseManager.listForClient($scope.client.id, expenseQuery);
    $q.all([entriesRequest, expensesRequest, chargesRequest]).spread(function (entries, expenses, charges) {
      $scope.loading = false;
      $scope.entries = entries;
      $scope.items = {
        hours: {
          hours: 0,
          amount: 0
        }
      };
      var group = _.groupBy(entries, function (e) {
        return e.billingType === 'billable';
      });
      $scope.billableEntries = group[true] || [];
      $scope.nonBillableEntries = group[false] || [];
      $scope.billableEntries.forEach(function (e) {
        $scope.items.hours.hours += e.billedHours;
        $scope.items.hours.amount += calculateEntryAmount(e.rate.amount, e.billedHours);
      });
      $scope.items.hours.matterIds = matterIds($scope.billableEntries);
      if ($scope.nonBillableEntries.length) {
        $scope.items.none = {
          hours: _.reduce($scope.nonBillableEntries, function (sum, e) {
            return sum + e.hours;
          }, 0),
          include: true,
          matterIds: matterIds($scope.nonBillableEntries)
        };
      }
      $scope.items.hours.include = $scope.items.hours.amount > 0;
      $scope.items.computed = [];

      // Add service fee to computed fields
      const fees = $scope.me.company.settings.fees;
      if (fees && fees.services) {
        let d = new Date();
        d.setMonth(d.getMonth() + 1);
        d.setDate(0);
        let label = fees.serviceLabel || 'Administrative Fee (%)';
        label = label.replace('%', fees.services + '%');
        $scope.items.computed.push({
          include: true,
          amount: 0.0,
          // Calculated on total() function call
          accountingService: fees.accountingService || ($scope.me.company.settings.expenses ? $scope.me.company.settings.expenses.accountingService : null),
          description: label,
          computed: {
            services: true,
            settings: fees
          },
          date: d
        });
      }

      // by user (only calculate if there are multiple users or if they are not us)
      var userGrouping = _.groupBy(entries, e => e.account.id);
      var users = _.keys(userGrouping);
      if (users.length != 1 || users[0].id != $scope.me.id) {
        $scope.userTotals = _.map(userGrouping, function (userEntries, id) {
          var account = userEntries[0].account;
          var billableGroup = _.groupBy(userEntries, e => e.billingType == 'billable');
          var billableEntries = billableGroup[true] || [];
          var nonBillableEntries = billableGroup[false] || [];
          var total = {
            name: account.name,
            billable: _.reduce(billableEntries, (sum, e) => e.billedHours + sum, 0),
            nonBillable: _.reduce(nonBillableEntries, (sum, e) => e.hours + sum, 0),
            amount: _.reduce(billableEntries, (sum, e) => calculateEntryAmount(e.rate.amount, e.billedHours) + sum, 0)
          };
          return total;
        });
      }
      $scope.charges = charges;
      if (charges && charges.length) {
        $scope.items.charges = _.map(charges, function (charge) {
          // the request for charges include start and end date (optionally)
          // but for charges we don't want them to be included if the date
          // is later than today.
          if (charge.date) {
            charge.include = new Date(charge.date) <= new Date();
          } else {
            charge.include = true;
          }
          charge.matterIds = matterIds($scope.charges);
          if (charge.limit && $scope.items.none) {
            if ($scope.items.none.hours > charge.limit.hours) {
              // Hourly limit exceeded
              var hours = Math.round(($scope.items.none.hours - charge.limit.hours) * 10) / 10;
              $scope.items.extra = {
                hours: hours,
                include: true,
                amount: calculateEntryAmount(charge.limit.rate.amount, hours),
                rate: {
                  amount: charge.limit.rate.amount
                },
                limitHours: charge.limit.hours,
                matter: charge.matter
              };
            }
          }
          return charge;
        });
        if ($scope.items.none) {
          $scope.items.none.include = !!_.find($scope.items.charges, c => c.include);
        }
      }
      if ($scope.items.hours.hours && !$scope.items.hours.amount) {
        var message = ($scope.matter ? 'The ' + $scope.me.terms.matter + ' does' : 'One or more ' + $scope.me.terms.matter + 's do') + ' not have rates set up. Click this message to set up rates.';
        alerts.create({
          type: 'warn',
          content: message,
          timeout: 0,
          clickable: true
        }).then(() => {
          if (!$scope.matter) {
            return $state.go('clients.client', {
              id: $scope.client.id
            });
          }
          return $state.go('matters-next.client.matter.access', {
            id: $scope.matter.client.id,
            matterId: $scope.matter.id
          });
        });
      }
      $scope.expenses = expenses;
      if (expenses && expenses.length) {
        $scope.items.expenses = {
          //todo change
          amount: _.reduce(expenses, function (sum, e) {
            return sum + e.amount;
          }, 0),
          include: true,
          matterIds: matterIds($scope.expenses)
        };
      }
      $scope.items.nothing = (!$scope.items.none || !$scope.items.none.hours) && !$scope.items.hours.hours && (!$scope.items.expenses || !$scope.items.expenses.amount) && (!$scope.items.fixed || !_.find($scope.items.fixed, function (f) {
        return f.include;
      })) && !$scope.items.charges;
    });
  }
}]);